export const HOMEPAGE = 'https://wagwalking.com';
export const URL_WAG_TAG_LOGIN = '/login';
export const URL_WAG_TAG_ORDER_PAGE = '/order';
export const URL_WAG_TAG_ORDER_SUCCESS = '/order/success';
export const URL_WAG_TAG_TERMS = '/terms';
export const URL_GENERAL_TERMS_AND_CONDITIONS = 'https://wagwalking.com/terms/?plain=1';
export const URL_WAG_TAG_SHELTER = '/shelter';
export const URL_WAG_TAG_SHELTER_ORDER = '/shelter/order';
export const URL_WAG_TAG_SHELTER_ORDER_SUCCESS = '/shelter/order/success';
export const URL_ANDROID_APP_DOWNLOAD = 'https://wagwalking.com/download/android?campaign=footer';
export const URL_IOS_APP_DOWNLOAD = 'https://wagwalking.com/download/ios?campaign=footer';

export const URL_APP_LOGIN = 'https://app.wagwalking.com/login';
export const URL_APP_FORGOT_PASSWORD = 'https://app.wagwalking.com/forgot-password';
export const URL_BECOME_A_WALKER = 'https://wagwalking.com/dog-walker';
export const URL_BOOK_DAYCARE = 'https://wagwalking.com/book/daycare';
export const URL_BOOK_OVERNIGHT = 'https://wagwalking.com/book/overnight';
export const URL_BOOK_SITTING = 'https://book.wagwalking.com/dog-boarding-3/confirm-dates?service=sitting';
export const URL_BOOK_BOARDING = 'https://book.wagwalking.com/dog-boarding-3/confirm-dates?service=boarding';
export const URL_BOOK_WALK = 'https://wagwalking.com/book/walk';
export const URL_EXTERNAL_CAREERS = 'https://hire.withgoogle.com/public/jobs/wagwalkingcom';
export const URL_DAILY_WAG = 'https://wagwalking.com/daily';
export const URL_DOG_BOARDING_SERVICE = 'https://book.wagwalking.com/dog-boarding-3/confirm-dates';
export const URL_DOG_DAYCARE_SERVICE = 'https://book.wagwalking.com/dog-boarding-3';
export const URL_HELP_CENTER = 'https://help.wagwalking.com';

export const URL_DOG_DAYCARE_LANDING_PAGE = 'https://wagwalking.com/dog-daycare';
export const URL_DOG_BOARDING_LANDING_PAGE = 'https://wagwalking.com/dog-boarding';
export const URL_DOG_SITTING_LANDING_PAGE = 'https://wagwalking.com/dog-sitting';
export const URL_DOG_WALKING_LANDING_PAGE = 'https://wagwalking.com/dog-walking';
export const URL_WAG_TAG_LANDING_PAGE = 'https://tag.wagwalking.com';
export const URL_DOG_DROPINS_LANDING_PAGE = 'https://wagwalking.com/drop-ins';

export const URL_LOST_DOG_PROFILE = tagSerialNumber => `/report-lost/${tagSerialNumber}`;

export const URL_SHELTER_DOG_PROFILE = tagSerialNumber => `/shelter/tag/${tagSerialNumber}`;
